<template>
	<v-container grid-list-xs>
		<v-card>
			<v-card-title primary-title>
				<v-btn
					icon
					@click="
						$inertia.visit(
							$route('tenant.products.index', $page.props)
						)
					"
					><v-icon>mdi-arrow-left</v-icon></v-btn
				>
				{{ $t("title.show_product") }}
			</v-card-title>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 md8>
						<v-layout row wrap>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3"
									>{{ $t("Name") }}:</v-list-item-title
								>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title
									class="mt-3 pl-5 font-weight-black"
									>{{ product.name }}</v-list-item-title
								>
							</v-flex>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3"
									>{{ $t("label.slug") }}:</v-list-item-title
								>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title
									class="mt-3 pl-5 font-weight-black"
									>{{ product.slug }}</v-list-item-title
								>
							</v-flex>

							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3"
									>{{ $t("Price") }}:</v-list-item-title
								>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title
									class="mt-3 pl-5 font-weight-black"
									>{{ product.price }}</v-list-item-title
								>
							</v-flex>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3"
									>{{ $t("Type") }} :</v-list-item-title
								>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title
									class="mt-3 pl-5 font-weight-black"
									>{{ product.type }}</v-list-item-title
								>
							</v-flex>

							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3"
									>{{ $t("label.unit") }} :</v-list-item-title
								>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title
									class="mt-3 pl-5 font-weight-black"
									>{{ product.unit_name }}</v-list-item-title
								>
							</v-flex>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3"
									>{{
										$t("label.category")
									}}:</v-list-item-title
								>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title
									class="mt-3 pl-5 font-weight-black"
									>{{
										product.category_name
									}}</v-list-item-title
								>
							</v-flex>
							<v-flex xs12 md6>
								<v-switch
									v-model="product.enabled_reservation"
									:label="$t('label.enabled_reservation')"
									readonly
								></v-switch>
							</v-flex>
							<v-flex xs12 md6>
								<v-switch
									v-model="product.enabled_pickup"
									:label="$t('label.enabled_pickup')"
									readonly
								></v-switch>
							</v-flex>
							<v-flex xs12 md6>
								<v-switch
									v-model="product.enabled_order"
									:label="$t('label.enabled_order')"
									readonly
								></v-switch>
							</v-flex>
							<v-flex xs12 md6>
								<v-switch
									v-model="product.enabled_delivery"
									:label="$t('label.enabled_delivery')"
									readonly
								></v-switch>
							</v-flex>

							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3"
									>{{ $t("Description") }}:</v-list-item-title
								>
							</v-flex>
							<v-flex xs4 md10>
								<v-list-item-title
									class="mt-3 pl-5 font-weight-black"
									>{{
										product.description
											? product.description
											: "N/A"
									}}</v-list-item-title
								>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs12 md4>
						<v-layout row wrap>
							<v-flex xs10 md4>
								<v-img
									:src="
										product
											? product.image_url
											: '/images/image_placeholder.jpg'
									"
									style="h-0.5, min-w-0.5"
								></v-img>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
export default {
	props: ["product"],
};
</script>